import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/layout/menuSidebar/sidebar"
import type { MenuItem } from "@/components/ui/layout/menuSidebar/type-sidebar"
import { matchUrlPatterns } from "@/modules/navigation/utils"
import { useMenuModels } from "@modules/app/hooks/useMenuModel"
import { Link } from "react-router"

function NavMainItem({ item }: { item: MenuItem }) {
  const isActive = matchUrlPatterns(item.relativeTo ?? [], window.location.pathname)

  return (
    <SidebarMenuItem key={item.label}>
      <SidebarMenuButton
        isActive={isActive}
        render={
          <Link to={item.to ?? ""}>
            {item.icon}
            <span>{item.label}</span>
          </Link>
        }
      />
    </SidebarMenuItem>
  )
}
export function NavMain({ className }: { className?: string }) {
  const menuModels: MenuItem[] = useMenuModels()

  return (
    <SidebarGroup className={className}>
      <SidebarMenu>
        {menuModels.map((item) => (
          <NavMainItem key={item.label} item={item} />
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )
}
